// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"1c7e3da6","855":"1c7e3da6"}[chunkId] + ".chunk.css";
};